import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { RoblexModalRef } from '../../config';
import { DataURLtoFile } from '../../constants/data-url-to-file.constant';
import { CameraService } from './camera.service';

@Component({
    selector: 'robch-camera',
    templateUrl: './camera.component.html',
    styleUrls: ['./camera.component.scss'],
    providers: [CameraService],
})
export class CameraComponent implements OnInit, OnDestroy {
    /**
     * Video element of camera component
     */
    videoElement!: HTMLVideoElement;
    /**
     * Img  of camera component
     */
    image!: string;
    /**
     * Stream  of camera component
     */
    stream!: any;
    /**
     * Loading$  of camera component
     */
    loading$: Subject<boolean> = new Subject();
    /**
     * Creates an instance of camera component.
     */
    constructor(
        // private http: HttpClient,
        private cameraService: CameraService,
        private roblexModalRef: RoblexModalRef
    ) {}
    /**
     * on init
     */
    ngOnInit(): void {
        if (this.hasGetUserMedia()) {
            // Good to go!
            this.setConfigCamera();
        } else {
            alert('getUserMedia() is not supported by your browser');
        }
    }
    /**
     * on destroy
     */
    ngOnDestroy(): void {
        this.stream.stop();
    }

    onClickTake() {
        const canvas: any = document.createElement(
            'canvas'
        ) as HTMLCanvasElement;
        canvas.width = this.videoElement.videoWidth;
        canvas.height = this.videoElement.videoHeight;
        canvas.getContext('2d').drawImage(this.videoElement, 0, 0);
        // Other browsers will fall back to image/png
        this.image = canvas.toDataURL('image/jpeg');
    }

    async onClickAccept(): Promise<void> {
        try {
            this.loading$.next(true);
            const response = await this.cameraService
                .upload(
                    DataURLtoFile(
                        this.image,
                        `TAKE_${new Date().getTime()}.jpeg`
                    )
                )
                .toPromise();
            this.roblexModalRef.close(response);
        } catch (error) {
            // console.error(error);
        } finally {
            this.loading$.next(false);
        }
    }

    onClickClear() {
        this.image = '';
    }

    onClickClose() {
        this.roblexModalRef.close();
    }

    private setConfigCamera() {
        this.videoElement = document.querySelector(
            '.wrapper-video'
        ) as HTMLVideoElement;
        navigator.mediaDevices
            .getUserMedia({
                video: true,
            })
            .then((stream) => {
                this.stream = stream.getTracks()[0];
                this.videoElement.srcObject = stream;
            })
            .catch();
    }

    private hasGetUserMedia() {
        return !!(
            navigator.mediaDevices && navigator.mediaDevices.getUserMedia
        );
    }
}

/*
document.querySelector("#start-camera").addEventListener('click', async function() {
    // suppose we require a full HD video
    let constraints = { 
                        audio: true, 
                        video: { 
                            width: { ideal: 1920 }, 
                            height: { ideal: 1080 } 
                        }
                    };

    let stream = await navigator.mediaDevices.getUserMedia(constraints);

    let stream_settings = stream.getVideoTracks()[0].getSettings();

    // actual width & height of the camera video
    let stream_width = stream_settings.width;
    let stream_height = stream_settings.height;

    console.log('Width: ' + stream_width + 'px');
    console.log('Height: ' + stream_height + 'px');
});


*/
